module.exports = __webpack_public_path__ + "static/media/country_gs.846fe895.webp";